(function(module) {
    'use strict';

    function RegisterAccountConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('register-account', {
                url: '/register-account',
                data: {
                    pageTitle: 'REGISTER_ACCOUNT.PAGE_TITLE',
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl',
                    },
                    'content@register-account': {
                        templateUrl: '/js/authentication/register-account/register-account.html',
                        controller: 'RegisterAccountCtrl as $ctrl',
                    },
                },
                resolve: {
                    user: (User, $state) => {
                        return User.getCurrent()
                            .$promise
                            .then((user) => {
                                if (!user.emailVerified && !user.enabled) {
                                    $state.go('login');
                                }

                                if (user.emailVerified && user.accountId && user.enabled) {
                                    $state.go('root.home');
                                }
                            });
                    },
                },
                bodyClass: 'page--register-account',
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/register-account');

    }

    function RegisterAccountCtrl(Account, $state) {
        this.createAccount = () => {
            const date = Date.now();
            Account.create({
                ...this.account,
                accountVerified: true,
                agreementSigned: true,
                agreementSignedDate: date,
            })
                .$promise
                .then(() => {
                    $state.go('root.home');
                })
                .catch((error) => {
                    console.error(error);
                    $state.go('root.login');
                    Raven.captureException(error);
                });
        };
    }

    module
        .config(RegisterAccountConfig)
        .controller('RegisterAccountCtrl', RegisterAccountCtrl);

})(angular.module('rocket.components'));
